import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { Button } from "@/components/ui/button";
import { Link } from "wouter";
import { motion } from "framer-motion";
import { useEffect } from "react";
import { CheckCircle } from "lucide-react";

export default function ThankYou() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background font-sans flex flex-col">
      <Navbar forceScrolled={true} />

      <main className="flex-grow flex items-center justify-center py-24 bg-white mt-20">
        <div className="container mx-auto px-6 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-2xl mx-auto flex flex-col items-center"
          >
            <CheckCircle className="text-primary w-24 h-24 mb-8" />
            <h1 className="text-5xl md:text-7xl font-heading font-black text-black mb-6 uppercase italic tracking-tighter">
              Thank <span className="text-primary">You</span>
            </h1>
            <p className="text-black text-xl font-medium leading-relaxed mb-10">
              Your message has been sent successfully. Our team will get back to you shortly.
            </p>
            <Link href="/" className="inline-block">
                <Button size="lg" className="bg-primary text-black hover:bg-black hover:text-white text-lg px-10 h-16 rounded-none font-black uppercase italic transition-all cursor-pointer">
                  Back to Home
                </Button>
            </Link>
          </motion.div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
